import React from 'react';
import { useFieldAttributes } from '../../../sdk/components';
import { FieldDescriptionWUT, FieldErrorWUT, FieldLabelWUT } from '../../../sdk/components-wut';
import { getDateTimePartsErrors } from '../../../ui/date-time-field/date-time-field-utils';
import { DateTimeFieldWUT } from '../../../ui/date-time-field/date-time-field-wut';
export const DateTimeInputWUT = ({ id, description, target, value, error, hasError = false, errorMessage, required, label, hideLabel, FieldLayout, use24HourFormat, disabled, hidePlaceholder, showDateLabels, requiredIndicatorType, requiredIndicatorPlacement, onBlur, onFocus, onChange })=>{
    const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
    return /*#__PURE__*/ React.createElement(FieldLayout, {
        fieldId: id,
        renderLabel: ()=>/*#__PURE__*/ React.createElement(FieldLabelWUT, {
                labelId: labelId,
                required: required,
                label: label,
                hideLabel: hideLabel,
                requiredIndicatorType: requiredIndicatorType,
                requiredIndicatorPlacement: requiredIndicatorPlacement
            }),
        renderInput: ()=>/*#__PURE__*/ React.createElement(DateTimeFieldWUT, {
                use24HourFormat: use24HourFormat,
                onBlur: onBlur,
                onChange: onChange,
                onFocus: onFocus,
                value: value ?? '',
                id: id,
                disabled: disabled,
                hidePlaceholder: hidePlaceholder,
                showDateLabels: showDateLabels,
                required: required,
                errors: getDateTimePartsErrors(hasError, value ?? ''),
                inputId: inputId,
                ariaLabelledBy: labelId,
                ariaDescribedBy: ariaDescribedBy
            }),
        renderDescription: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(FieldErrorWUT, {
                target: target,
                hasError: hasError,
                errorMessage: errorMessage,
                id: errorId
            }), /*#__PURE__*/ React.createElement(FieldDescriptionWUT, {
                description: description,
                id: descriptionId
            }))
    });
};

//# sourceMappingURL=date-time-input-wut.js.map